import { useEffect, useState } from 'react';
import { useToast } from '../../../shared/hooks/use-toast';
import { listZoneKinds, type ZoneKind } from '../../reference-data/reference-data.api';
import { createZone, type Zone } from '../zones.api';

/** The zone-kind choices (fetched when the modal opens) and the create call for starting a zone on the spot, from another unit's form. */
export function useZoneQuickCreate(open: boolean) {
  const [kinds, setKinds] = useState<ZoneKind[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (!open) return;
    listZoneKinds()
      .then((all) => {
        setKinds(all.filter((kind) => kind.isActive));
        setError(null);
      })
      .catch(() => setError('Could not load the zone kinds.'));
  }, [open]);

  async function create(values: { name: string; code: string; kind: string }): Promise<Zone | null> {
    setError(null);
    setSaving(true);
    try {
      const zone = await createZone(values);
      toast.success(`Zone ${zone.name} created`);
      return zone;
    } catch {
      setError('Could not create the zone — the code may already be taken.');
      return null;
    } finally {
      setSaving(false);
    }
  }

  return { kinds, error, saving, create };
}
